type RoleBearingUser = {
  roles?: unknown;
  [key: string]: unknown;
};

const stringRoles = (value: unknown): string[] => (
  Array.isArray(value)
    ? value.filter((role): role is string => typeof role === 'string' && role.trim().length > 0)
    : []
);

export const normalizeAuthUser = <T extends RoleBearingUser>(
  user: T,
  responseRoles?: unknown,
): T & { roles: string[] } => {
  const embeddedRoles = stringRoles(user.roles);
  const roles = Array.isArray(user.roles) ? embeddedRoles : stringRoles(responseRoles);
  return { ...user, roles };
};
